import React, { useState, useRef } from "react";

import * as accountsReducer from "containers/Accounts/reducer";
import * as languageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";

import { LineInput } from "components/Inputs/LineInput";
import { Creatable } from "react-select";

import { useDispatch, useSelector } from "types/store";

import { Button } from "aible";

import styles from "./style.module.css";

import CreateAppIcon from "images/circle-plus-light-purple.svg";
import AccountSelector from "containers/Accounts/AccountSelector";

import { MODELS } from "containers/ChatGPT/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const ModelUpload = ({ buttonType, buttonText, buttonStyle, buttonLogo, buttonLogoClass }) => {
  const [showModal, updateShowModal] = useState(false);
  const baseModelOptions = useSelector((state) =>
    languageModelArtifactReducer.getFineTuneBaseModelOptions(state).filter((option) => option.value === MODELS.MISTRAL)
  );
  const [baseModel, updateBaseModel] = useState(baseModelOptions[0]?.value);

  return (
    <React.Fragment>
      {buttonType ? (
        <Button
          onClick={() => {
            updateShowModal(true);
          }}
          style={buttonStyle}
        >
          <img className={buttonLogoClass} src={buttonLogo} />
          {buttonText}
        </Button>
      ) : (
        <UploadTile
          showModal={showModal}
          updateShowModal={updateShowModal}
          baseModel={baseModel}
          updateBaseModel={updateBaseModel}
        />
      )}

      <UploadModal
        showModal={showModal}
        updateShowModal={updateShowModal}
        baseModel={baseModel}
        updateBaseModel={updateBaseModel}
      />
    </React.Fragment>
  );
};

const UploadTile = ({ updateShowModal, baseModel, updateBaseModel } = {}) => {
  const baseModelOptions = useSelector((state) =>
    languageModelArtifactReducer.getFineTuneBaseModelOptions(state).filter((option) => option.value === MODELS.MISTRAL)
  );

  return (
    <div
      className={styles.uploadModelsTile}
      onClick={() => {
        updateShowModal(true);
      }}
    >
      <div className={styles.uploadModelsTitle}>{"Create Custom Model"}</div>
      <div className={styles.uploadModelsText}>{"Upload LoRA weights for"}</div>
      <div
        className={styles.trainingTileInput}
        onClick={(e) => {
          e.stopPropagation();
          console.log(baseModelOptions);
        }}
      >
        <Creatable
          options={baseModelOptions}
          value={baseModelOptions.find((o) => o.value === baseModel)}
          onChange={(val) => updateBaseModel(val?.value)}
          placeholder={"Select a Base Model"}
          menuPlacement={"bottom"}
          isDisabled={baseModelOptions?.length < 2}
        />
      </div>
      <div className={styles.uploadModelsIcon}>
        <img src={CreateAppIcon} alt={"Create Custom Model"} />
      </div>
    </div>
  );
};

const UploadButton = ({ onChange, isActive } = {}) => {
  const fileInputRef = useRef();

  const handleChange = (e) => {
    console.log(e.target);
    onChange(e.target.files[0]);
  };

  return (
    <React.Fragment>
      <Button type={!isActive ? "secondary" : "primary"} onClick={() => fileInputRef.current.click()}>
        {"Upload Model"}
      </Button>
      <input
        onChange={handleChange}
        multiple={false}
        ref={fileInputRef}
        type="file"
        hidden
        style={{ display: "none" }}
      />
    </React.Fragment>
  );
};

const UploadModal = ({ showModal, updateShowModal, baseModel, updateBaseModel } = {}) => {
  const dispatch = useDispatch();

  const accounts = useSelector((state) => accountsReducer.getActiveAccounts(state));
  const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));

  const [modelName, updateModelName] = useState();
  const [isLoading, updateIsLoading] = useState();
  const [modelFile, updateModelFile] = useState();

  const baseModelOptions = useSelector((state) =>
    languageModelArtifactReducer.getFineTuneBaseModelOptions(state).filter((option) => option.value === MODELS.MISTRAL)
  );

  const handleModelCreate = () => {
    updateIsLoading(true);
    dispatch(
      languageModelArtifactReducer.uploadCustomModel(baseModel, modelName ?? "Custom Model", modelFile, accountId)
    ).finally(() => {
      updateIsLoading(false);
      updateModelName(undefined);
      updateModelFile(undefined);
      updateShowModal(false);
    });
  };

  return (
    <Dialog open={showModal} onOpenChange={() => updateShowModal(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{"Create Custom Model"}</DialogTitle>
        </DialogHeader>
        <div>
          <div className={styles.trainingOptionRow}>
            <div className={styles.trainingOptionLabel}>{"New Model Name"}</div>
            <div className={styles.trainingInput}>
              <LineInput
                value={modelName}
                onChange={(val) => updateModelName(val)}
                style={{ width: "100%" }}
                placeholder={"Custom Model"}
              />
            </div>
          </div>
          <div className={styles.trainingOptionRow} style={{ marginBottom: "20px" }}>
            <div className={styles.trainingOptionLabel}>{"Base Model"}</div>
            <div className={styles.trainingInput}>
              <Creatable
                options={baseModelOptions}
                value={baseModelOptions.find((o) => o.value === baseModel)}
                onChange={(val) => updateBaseModel(val?.value)}
                placeholder={"Select a Base Model"}
                menuPlacement={"bottom"}
                isDisabled={baseModelOptions?.length < 2}
              />
            </div>
          </div>
          {accounts?.length > 1 && (
            <div className={styles.trainingOptionRow} style={{ marginBottom: "20px" }}>
              <AccountSelector />
            </div>
          )}
          <div className={styles.trainingOptionRow} style={{ marginBottom: "20px" }}>
            <UploadButton
              onChange={(modelFile) => {
                updateModelFile(modelFile);
              }}
              isActive={!modelFile}
            />
            {modelFile && <div>{modelFile.name}</div>}
          </div>
        </div>
        <DialogFooter>
          <Button
            onClick={() => {
              updateShowModal(false);
            }}
          >
            {"Close"}
          </Button>
          <Button onClick={handleModelCreate} type={"primary"} isLoading={isLoading} disabled={!modelFile}>
            {"Create Custom Model"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModelUpload;
